export enum ETransferType {
  INTERNATIONAL = 'INTERNATIONAL',
  INTERNAL = 'INTERNAL'
}